<template>
	<div>
		<div class="flex h-full items-center">
			<div class="flex" v-if="showDropShipping && order.order.dropship">
				<vx-tooltip text="Deze bestelling is besteld bij dropship leverancier">
					<vs-chip color="dark">Dropshipping</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 2">
				<vx-tooltip text="Deze bestelling staat nog open">
					<vs-chip color="primary">Open</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 3">
				<vx-tooltip text="Deze bestelling is verwerkt">
					<vs-chip color="success">Verwerkt</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 4">
				<vx-tooltip text="Deze bestelling is geannuleerd">
					<vs-chip color="danger">Geannuleerd</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 5">
				<vx-tooltip text="Verzenden in behandeling">
					<vs-chip color="dark">Verzenden...</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 6">
				<vx-tooltip text="Annuleren in behandeling">
					<vs-chip color="dark">Annuleren...</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 7">
				<vx-tooltip text="Deze bestelling is gemarkeerd als verwerkt">
					<vs-chip color="success">Gemarkeerd als verwerkt</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 8">
				<vx-tooltip text="Het verzenden van deze bestelling is mislukt.">
					<vs-chip color="danger">Verzenden mislukt</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 9">
				<vx-tooltip text="Bestelling staat in de wacht.">
					<vs-chip color="danger">On hold</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 10">
				<vx-tooltip text="Bestelling is nog niet betaald door klant">
					<vs-chip color="danger">Wacht op betaling</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 11">
				<vx-tooltip text="Bestelling is klaar om te verzenden.">
					<vs-chip color="primary">Wachten op verzending</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 12">
				<vx-tooltip text="Bestelling staat klaar om afgehaald te worden.">
					<vs-chip color="success">Wachten op afhaal</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 13">
				<vx-tooltip text="Bestelling staat klaar om afgehaald te worden.">
					<vs-chip color="danger">Wachten op afhaal</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 14">
				<vx-tooltip text="Bestelling is afgehaald.">
					<vs-chip color="success">Afgehaald</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 15">
				<vx-tooltip text="Bestelling is verzonden.">
					<vs-chip color="success">Verzonden</vs-chip>
				</vx-tooltip>
			</div>
			<div class="flex" v-if="order.order.status === 16">
				<vx-tooltip text="Deze bestelling is verwijdert.">
					<vs-chip color="dark">Verwijdert</vs-chip>
				</vx-tooltip>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'order-status',
	props: {
		order: {
			type: Object,
			required: true
		},
		showDropShipping: {
			type: Boolean,
			default: true,
		}
	},
}
</script>
